// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import HomePage from './Views/HomePage';
import Experience from './Views/Experience';
import Projects from './Views/Projects';
import Design from './Views/Design';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/design" element={<Design />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;

